import Vue from "vue";

export const getLatestPrivacyPolicy = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .get("privacy_policy/latest")
      .then(call => {
        commit("SET_LATEST_PRIVACY_POLICY", call.data);
        resolve(call.data);
      })
      .catch(() => reject());
  });
};

// export const getLatestPrivacyPolicyToAccept = ({ commit }) => {
//   return new Promise((resolve, reject) => {
//     Vue.$axios
//       .get("privacy_policy/latest_to_accept")
//       .then(call => {
//         commit("SET_LATEST_PRIVACY_POLICY_TO_ACCEPT", call.data);
//         resolve(call.data);
//       })
//       .catch(() => reject());
//   });
// };

export const confirm = ({ commit }, version) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .patch("privacy_policy/" + version + "/accept")
      .then(call => {
        commit("SET_LATEST_PRIVACY_POLICY", call);
        resolve();
      })
      .catch(() => reject());
  });
};
